// extracted by mini-css-extract-plugin
export var header = "header-module--header--qEDXG";
export var header__heading = "header-module--header__heading--BCNcZ";
export var header__link = "header-module--header__link--5fbf5";
export var header__linkHome = "header-module--header__link--home--VZO3b";
export var header__nav = "header-module--header__nav--upGjn";
export var header__wrap = "header-module--header__wrap--pX-lE";